var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancedPrograming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e93f332e-24e1-40c0-be2c-eeb17684d115",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M66.577,20.311H50.769a1.412,1.412,0,0,1,0-2.824H66.577a1.412,1.412,0,1,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M45.6,20.09H37.75a1.412,1.412,0,0,1,0-2.824H45.6a1.412,1.412,0,0,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M45.6,42.734H37.75a1.412,1.412,0,0,1,0-2.824H45.6a1.412,1.412,0,0,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M37.7,14.429H33.423a1.412,1.412,0,1,1,0-2.824H37.7a1.412,1.412,0,0,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M37.7,48.4H33.423a1.412,1.412,0,1,1,0-2.824H37.7a1.412,1.412,0,0,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M46.352,25.751H42.077a1.412,1.412,0,1,1,0-2.824h4.275a1.412,1.412,0,1,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M46.352,37.073H42.077a1.412,1.412,0,0,1,0-2.824h4.275a1.412,1.412,0,1,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M60.588,25.751H50.924a1.412,1.412,0,1,1,0-2.824h9.664a1.412,1.412,0,0,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M52.766,31.412H46.4a1.412,1.412,0,0,1,0-2.824h6.362a1.412,1.412,0,0,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M63.852,31.412H57.489a1.412,1.412,0,0,1,0-2.824h6.363a1.412,1.412,0,0,1,0,2.824Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b1ce1ebf-1e52-49ae-b2e0-1b218ebb767d",
    d: "M65.264,14.429H42.75a1.412,1.412,0,1,1,0-2.824H65.264a1.412,1.412,0,1,1,0,2.824Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedPrograming);
export default __webpack_public_path__ + "static/media/AdvancedPrograming.ac2415ab1a750afed57a9b26dfe6e669.svg";
export { ForwardRef as ReactComponent };